import React, { useEffect, useState } from "react";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useAuth from "hooks/useAuth";
import "react-phone-number-input/style.css";

import api from "assets/services/api";

function ModalUpdateAnalytical(props) {
  const [br, setBR] = useState(false);

  const [code, setCode] = useState(props.props.code);
  const [description, setDescription] = useState(props.props.description);
  const [subsynthetics, setSubSynthetics] = useState([]);
  const [id_subsynthetic, setId_subsynthetic] = useState();
  const { storageId } = useAuth();
  const [controlSnack, setControlSnack] = useState(false);

  const showNotification = (place) => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) showNotification("br");
  }, [controlSnack]);
  useEffect(() => {
    getAllSynthetics();
  }, []);

  async function handleUpdateAnalytical(e) {
    e.preventDefault();
    const response = await api.put("/analytical/" + props.props.id, {
      description: description,
      id_admin: storageId,
      id_subsynthetic: id_subsynthetic,
      code: code
    });
    if (response.data.error) {
      return alert(response.data.error);
    }
    props.getAllAnalytical();
    props.onHide();
  }

  async function getAllSynthetics() {
    const response = await api.get(
      "/subsynthetic?id_admin=" + storageId
    );
    setSubSynthetics(response.data);
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar analítico
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleUpdateAnalytical}>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridDescription">
              <Form.Label>Código</Form.Label>
              <Form.Control
                onChange={(event) => setCode(event.target.value)}
                value={code}
                type="text"
                placeholder="Código do analítico"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDescription">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                onChange={(event) => setDescription(event.target.value)}
                value={description}
                type="text"
                placeholder="Nome da analítico"
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridSynthetic">
              <Form.Label>Sub-Sintéticos</Form.Label>
              <Form.Control
                onChange={(event) => setId_subsynthetic(event.target.value)}
                value={id_subsynthetic}
                as="select"
              >
                {subsynthetics.map((subsynthetic) => (
                  <option key={String(subsynthetic.id)} value={subsynthetic.id}>
                    {subsynthetic.code} - {subsynthetic.description}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>
        </Modal.Body>
        <Modal.Footer>
          <div classname_car="d-flex justify-content-center">
            <Button color="success" type="submit">
              Editar analítico
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Carro editado com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalUpdateAnalytical;
